var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0354 20.0007C40.0354 30.1016 32.5502 38.4523 22.8262 39.8074C21.917 39.9335 20.9868 39.9993 20.0426 39.9993C18.9527 39.9993 17.8823 39.9125 16.84 39.7443C7.32067 38.2112 0.0498047 29.9545 0.0498047 20.0007C0.0498047 8.95523 9.00179 0.000610352 20.044 0.000610352C31.0862 0.000610352 40.0382 8.95523 40.0382 20.0007H40.0354Z",
    fill: "url(#paint0_linear_115_1087)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8274 16.06V20.4168H28.2154L27.3622 26.2856H22.8274V39.8073C21.9182 39.9334 20.988 39.9993 20.0437 39.9993C18.9538 39.9993 17.8835 39.9124 16.8412 39.7442V26.2856H11.8721V20.4168H16.8412V15.0861C16.8412 11.7789 19.5212 9.09668 22.8288 9.09668V9.09949C22.8386 9.09949 22.847 9.09668 22.8568 9.09668H28.2168V14.1724H24.7145C23.6736 14.1724 22.8288 15.0174 22.8288 16.0586L22.8274 16.06Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_1087",
    x1: 40.0382,
    y1: 39.9993,
    x2: -8.19934,
    y2: 18.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.028b9bc9c2edc7f8f9bf74fb44c80082.svg";
export { ForwardRef as ReactComponent };